module.exports = __webpack_public_path__ + "static/media/supply_kit_4.b0825bb4.png";